<div class="confirm-dialog">
  <h2 matDialogTitle>Select season</h2>
  <p>Which season do you want to send?</p>
  <mat-dialog-actions>
    <button (click)="dialogRef.close('summer')" color="primary" mat-raised-button type="button">Summer</button>
    <button (click)="dialogRef.close('winter')" color="primary" mat-raised-button type="button">Winter</button>
    <button (click)="dialogRef.close(null)" mat-button type="button">Cancel</button>
  </mat-dialog-actions>
</div>
